import Model from "@ember-data/model";
export default class TimedTransaction extends Model {
  constructor(name, startDate, endDate, success, error) {
    super();
    this.name = name;
    this.startDate = startDate;
    this.endDate = endDate;
    this.success = success;
    this.error = error;
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.